/*
 * Keeps the frame on the first gallery image in sync with the selected variant.
 *
 * The frame is sized from --art-width-cm and --art-height-cm on the first media item, which the
 * section renders from the selected variant's custom.width_cm and custom.height_cm (see
 * 'product-media-gallery'). product-info patches the gallery item by item and never rewrites
 * the attributes of items that stay in place -- for variants without their own image it skips
 * the gallery entirely -- so the values are copied here from the freshly rendered section on
 * every variant change. The lightbox needs none of this: product-info replaces its content
 * wholesale.
 */
(() => {
  const FRAME_PROPERTIES = ['--art-width-cm', '--art-height-cm'];

  const frameClassesOf = (item) =>
    Array.from(item.classList).filter((name) => name === 'add_frame' || name.startsWith('frame_'));

  const syncFrame = (event) => {
    const { sectionId, html } = event.data;
    if (!html) return;

    const productInfo = Array.from(document.querySelectorAll('product-info')).find(
      ({ dataset }) => (dataset.originalSection || dataset.section) === sectionId
    );
    const gallery = productInfo?.querySelector('.product__media-list');
    const source = html.querySelector('.product__media-list li[data-media-id]');
    if (!gallery || !source) return;

    gallery.querySelectorAll('li[data-media-id]').forEach((item) => {
      const staleClasses = frameClassesOf(item);
      if (staleClasses.length) item.classList.remove(...staleClasses);
      FRAME_PROPERTIES.forEach((property) => item.style.removeProperty(property));
    });

    const first = gallery.querySelector('li[data-media-id]');
    const frameClasses = frameClassesOf(source);
    if (!first || !frameClasses.length) return;

    first.classList.add(...frameClasses);

    FRAME_PROPERTIES.forEach((property) => {
      const value = source.style.getPropertyValue(property);
      if (value) first.style.setProperty(property, value);
    });
  };

  subscribe(PUB_SUB_EVENTS.variantChange, syncFrame);
})();
